export const SUPPORTED_LANGS = ['fr', 'en', 'es', 'de'] as const;
export type AppLang = (typeof SUPPORTED_LANGS)[number];

export const DEFAULT_LANG: AppLang = 'fr';

export const LANG_LABELS: Record<AppLang, string> = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
};

/** BCP 47 tags for Intl / toLocaleString. */
export const LANG_BCP47: Record<AppLang, string> = {
  fr: 'fr-FR',
  en: 'en-US',
  es: 'es-ES',
  de: 'de-DE',
};

const STORAGE_KEY = 'terra.lang';

export function isAppLang(v: unknown): v is AppLang {
  return typeof v === 'string' && (SUPPORTED_LANGS as readonly string[]).includes(v);
}

export function loadStoredLang(): AppLang {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (isAppLang(raw)) return raw;
  } catch {
    /* ignore */
  }
  return DEFAULT_LANG;
}

export function saveStoredLang(lang: AppLang): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* ignore */
  }
}

export function applyDocumentLang(lang: AppLang): void {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
  }
}
